module.exports = __webpack_public_path__ + "static/media/GillSans-Light-08.94d1c36f.svg";